// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"453":"a04ae9d0","698":"c57c20d3"}[chunkId] + ".chunk.js";
};